import { Blueprint } from '@/components/builder/base/blueprints/Blueprint';
import { HasWidth } from '@/components/builder/base/traits/HasWidth';
import { BlueprintDefinition } from '@/components/builder/details/blueprints/BlueprintDefinition';
import { VisibleBlueprint } from '@/components/builder/form/blueprints/VisibleBlueprint';
import { AlwaysChoice } from '@/components/builder/form/enums/AlwaysChoice';
import { WhenChoice } from '@/components/builder/form/enums/WhenChoice';

export const Definition: BlueprintDefinition = {
    type: 'images-gallery',
    name: '[[[Galeria zdjęć]]]',
    icon: 'fa-image',
    group: 'functionalities',
    position: 7,
};

export interface ImagesGalleryContract extends Blueprint, VisibleBlueprint, HasWidth {}

export class ImagesGalleryType implements ImagesGalleryContract
{
    public id: string;
    public type: string;
    public name: string;
    public width: number;
    public minWidth: number;
    public visible: AlwaysChoice | WhenChoice;
    public visibleWhen: string;

    public mainImageField: string | null;
    public imagesField: string;
    public mainImagePreset: string;
    public thumbPreset: string;

    public constructor(id: string, name: string)
    {
        this.id = id;
        this.type = Definition.type;
        this.name = name;
        this.width = 0;
        this.minWidth = 2;
        this.visible = AlwaysChoice.Always;
        this.visibleWhen = null;
        this.mainImageField = null;
        this.imagesField = "";
        this.mainImagePreset = "";
        this.thumbPreset = "";
    }

    public setDefaultWidth(width: number): void
    {
        this.width = Math.min(3, Math.max(this.minWidth, width));
    }
}
